import React from 'react';
import AdsButton from './AdsButton';

const ALIGN_CLASS = {
  end: '',
  start: 'ads-modal-footer--start modal-form-actions-left',
  center: 'ads-modal-footer--center modal-form-actions-center',
  between: 'ads-modal-footer--between modal-form-actions-space-between',
};

/**
 * ADS Modal Footer — standard cancel / submit pattern (Phase 6).
 */
const AdsModalFooter = ({
  onCancel,
  cancelLabel,
  submitLabel,
  submitType = 'submit',
  submitDisabled = false,
  onSubmit,
  align = 'end',
  className = '',
  children,
}) => {
  const alignClass = ALIGN_CLASS[align] || '';
  const classes = ['ads-modal-footer', 'modal-form-actions', alignClass, className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={classes}>
      {onCancel != null && cancelLabel != null ? (
        <AdsButton variant="secondary" type="button" onClick={onCancel}>
          {cancelLabel}
        </AdsButton>
      ) : null}
      {children}
      {submitLabel != null ? (
        <AdsButton
          variant="primary"
          type={submitType}
          disabled={submitDisabled}
          onClick={onSubmit}
        >
          {submitLabel}
        </AdsButton>
      ) : null}
    </div>
  );
};

export default AdsModalFooter;
